import React, { useState, useEffect } from 'react';
import '../styles.css';
import { Form, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Toast from 'shared/common/toast';
import { userStore } from 'store/UserStore';
import infoIco from 'assets/images/i-circle.svg';
import successIco from 'assets/images/check.png';
import deleteIco from 'assets/images/delete.png';
import UserHttp from '../services/profile.service';

interface PropsType {
  handleModal: any;
  isShow: boolean;
  customerId: any;
}

const DocumentUpload: React.FC<PropsType> = ({
  handleModal,
  isShow,
  customerId,
}) => {
  const [isLoading, setLoading] = React.useState(false);
  const [user] = userStore((state: any) => [state.user]);
  const [selectedFile, setSelectedFile] = useState<any>(true);

  const [isPanUploading, setPanUploading] = useState(false);
  const [isPanUploadSuccess, setPanUploadSuccess] = useState(false);
  const [isPanUploadFeild, setPanUploadFeild] = useState(false);
  const [customerDocs, setCustomerDocs] = useState<any>([]);
  const [sampleDocs, setSampleDocs] = useState<any>([]);
  const [selectedSampleDoc, setSelectedSampleDoc] = useState<any>();
  const [docType, setDocType] = useState<any>();
  const [panOcr, setPanOcr] = useState<any>('');
  const toastId = React.useRef(null);
  const [sampleDocShow, setSampleDocShow] = useState<boolean>(false);
  const [sampleDocView, setSampleDocView] = useState<boolean>(false);

  useEffect((): any => {
    getDocs();
  }, []);

  const getDocs = async () => {
    try {
      const res: any = await UserHttp.getDocs(customerId);
      if (res.status === 200 && res.data.data) {
        const c_docs = res.data.data.docs.map((doc) => {
          return {
            ...doc,
            isUploading: false,
            isUploadSuccess: false,
            isUploadFeild: false,
          };
        });
        setCustomerDocs(c_docs);
      }
    } catch (e: any) {
      //toast.error(e);
      console.log(e);
    }
  };

  const getSampleDoc = async (id: any) => {
    setSampleDocs([]);
    try {
      const response: any = await UserHttp.getSampleDoc(id);
      if (response.status === 200 && response.data.data) {
        setSampleDocs(response.data.data);
        setSelectedSampleDoc({});
      }
    } catch (e: any) {
      //toast.error(e);
      console.log(e);
    }
  };

  const fileChanged = (event: any, docType: any, index: number) => {
    setSelectedFile(event.target.files[0]);
    onFileUpload(event, docType, index);
  };

  const onFileUpload = async (file, docType, index) => {
    //setLoading(true);
    // Create an object of formData
    uploadInprograss(index);
    const formData = new FormData();

    // Update the formData object
    formData.append('myFile', file.target.files[0], file.target.files[0].name);
    formData.append('customerId', customerId);

    formData.append('docTypeId', docType);

    // Details of the uploaded file
    try {
      const res: any = await UserHttp.uploadDoc(formData);
      if (res.status === 200 && res.data.data) {
        setCustomerDocs(res.data.data.docs);
        uploadSuccess(index);
      } else {
        uploadFeild(index);
      }
    } catch (e: any) {
      uploadFeild(index);
      console.log(e);
    }
  };

  const uploadInprograss = (index: number) => {
    const c_doc = customerDocs.filter((doc) => doc.index === index)[0];
    c_doc.isUploading = true;
    c_doc.isUploadSuccess = false;
    c_doc.isUploadFeild = false;
  };

  const uploadSuccess = (index: number) => {
    const c_doc = customerDocs.filter((doc) => doc.index === index)[0];
    c_doc.isUploading = false;
    c_doc.isUploadSuccess = true;
    c_doc.isUploadFeild = false;
  };

  const uploadFeild = (index: number) => {
    const c_doc = customerDocs.filter((doc) => doc.index === index)[0];
    c_doc.isUploading = false;
    c_doc.isUploadSuccess = false;
    c_doc.isUploadFeild = true;
  };

  const deleteFile = async (doc: any) => {
    uploadInprograss(doc.index);
    try {
      const res: any = await UserHttp.deleteDoc(doc.file.docUploadId);
      if (res) {
        getDocs();
        //setTimeout(function () {showToast()},1000);
        if (!toast.isActive(toastId.current)) {
          toastId.current = toast.success('Document has been deleted.');
        }
      }
      // doc.isUploading = false;
      handleModal(false);
    } catch (err: any) {
      console.log(err);

      toast.error(err.message);
    }
  };

  const showToast = async () => {
    toast.success('Document has been deleted.', {
      toastId: '1',
      updateId: '1',
    });
  };

  const getDocName = (resource: any) => {
    if (resource) {
      const arr = resource.split('/');
      return arr[arr.length - 1];
    }
    return '';
  };

  const download = async (data: any) => {
    const fileName = data.split('/').pop();
    try {
      const res: any = await UserHttp.downloadSampleDoc(
        encodeURIComponent(data)
      );
      if (res.status === 200 && res.data) {
        const href = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (e: any) {
      toast.error(e);
    }
  };

  const getAccepter = (type: any) => {
    if (type === 'IMG') {
      return 'image/*';
    }
    if (type === 'PDF') {
      return '.pdf';
    }
    if (type === 'IMG_OR_PDF') {
      return 'image/*,.pdf';
    }
    return '*';
  };

  return (
    <>
      <div
        onClick={() => handleModal(false)}
        className={`Backdrop 
        ${isShow ? 'BackdropActive' : ''}`}
      />
      <div
        className={`Sidebar ${isShow ? 'Open' : ''}`}
        style={{ width: '420px' }}
      >
        <div className='modal-header'>
          {sampleDocShow && (
            <a
              onClick={(event) => {
                event.preventDefault();
                if (sampleDocView) {
                  setSampleDocView(false);
                } else {
                  setSampleDocShow(false);
                }
              }}
              href=''
              className='flex font-medium text-gray-600 hover:text-gray-500'
            >
              <svg
                className='m-0.5'
                xmlns='http://www.w3.org/2000/svg'
                height='20px'
                viewBox='0 0 24 24'
                width='20px'
                fill='#000000'
              >
                <path d='M0 0h24v24H0z' fill='none' />
                <path d='M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z' />
              </svg>
            </a>
          )}
          <h4 className='modal-title'>
            {!sampleDocShow
              ? 'Upload Documents'
              : !sampleDocView
              ? 'Sample Business Documents'
              : 'Sample Doc view'}
          </h4>
          <span
            aria-hidden='true'
            className='Close'
            onClick={() => {
              setSampleDocView(false);
              setSampleDocShow(false);
              handleModal(false);
            }}
          >
            &times;
          </span>
        </div>
        <div
          className='px-5'
          style={{ overflowY: 'scroll', height: '80vh', position: 'relative' }}
        >
          {!sampleDocView ? (
            <>
              {!sampleDocShow ? (
                customerDocs.map((doc: any, index: number) => (
                  <div className='row py-4 justify-content-between'>
                    <div className='col-md-6 mb-2'>{doc.title}</div>
                    {Object.keys(doc?.file).length !== 0 ? (
                      <div
                        className='col-md-6 mb-2 form-group'
                        style={{ right: '14px' }}
                      >
                        <div className='error'>
                          <small id='my-helper-text'>
                            <img src={successIco} alt='' />
                            {`${doc.fileType} file is uploaded`}
                          </small>
                        </div>
                      </div>
                    ) : (
                      ''
                    )}

                    <div className='col-md-12'>
                      {doc.file && doc.uploaded ? (
                        <div className='input-group'>
                          <Button
                            variant='outline-secondary'
                            id='button-addon1'
                            style={{
                              border: '1px solid #ced4da',
                              backgroundColor: '#e9ecef',
                              color: 'black',
                            }}
                            onClick={() =>
                              document.getElementById(`docs_${index}`).click()
                            }
                          >
                            Choose file
                          </Button>
                          <Form.Control
                            type='text'
                            disabled
                            value={getDocName(doc?.file?.resource)}
                            aria-label='Example text with button addon'
                            aria-describedby='basic-addon1'
                          />
                          <Form.Control
                            type='file'
                            accept={getAccepter(doc.fileType)}
                            placeholder=''
                            name='docs'
                            className='form-control'
                            id={`docs_${index}`}
                            onChange={(e) => {
                              fileChanged(e, doc.docTypeId, doc.index);
                            }}
                            hidden
                          />
                          {doc.isUploading ||
                          doc.isUploadSuccess ||
                          doc.isUploadFeild ? (
                            <div className='input-group-text p-2'>
                              {doc.isUploading ? (
                                <div
                                  className='spinner-grow text-success'
                                  style={{ width: '1rem', height: '1rem' }}
                                  role='status'
                                >
                                  <span className='visually-hidden'>
                                    Loading...
                                  </span>
                                </div>
                              ) : (
                                ''
                              )}
                              {doc.isUploadSuccess ? (
                                <img
                                  style={{ width: '20px' }}
                                  src={successIco}
                                  alt=''
                                />
                              ) : (
                                ''
                              )}
                              {doc.isUploadFeild ? (
                                <img src={infoIco} alt='' />
                              ) : (
                                ''
                              )}
                            </div>
                          ) : (
                            <div className='input-group-text px-2'>
                              <button
                                className='btn p-0'
                                type='button'
                                onClick={() => {
                                  deleteFile(doc);
                                }}
                                id='button-addon2'
                              >
                                <img src={deleteIco} alt='' />
                              </button>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className='input-group'>
                          <Form.Control
                            type='file'
                            accept={getAccepter(doc.fileType)}
                            placeholder=''
                            name='docs'
                            className='form-control'
                            onChange={(e) => {
                              fileChanged(e, doc.docTypeId, doc.index);
                            }}
                          />
                          {doc.isUploading ||
                          doc.isUploadSuccess ||
                          doc.isUploadFeild ? (
                            <div className='input-group-text p-2'>
                              {doc.isUploading ? (
                                <div
                                  className='spinner-grow text-success'
                                  style={{ width: '1rem', height: '1rem' }}
                                  role='status'
                                >
                                  <span className='visually-hidden'>
                                    Loading...
                                  </span>
                                </div>
                              ) : (
                                ''
                              )}
                              {doc.isUploadSuccess ? (
                                <img
                                  style={{ width: '20px' }}
                                  src={successIco}
                                  alt=''
                                />
                              ) : (
                                ''
                              )}
                              {doc.isUploadFeild ? (
                                <img src={infoIco} alt='' />
                              ) : (
                                ''
                              )}
                            </div>
                          ) : (
                            ''
                          )}
                        </div>
                      )}
                      <div
                        className='col-md-6 mb-2 form-group'
                        style={{ left: '-13px' }}
                      >
                        <div className='error'>
                          <a
                            href='#'
                            onClick={() => {
                              getSampleDoc(doc.docTypeId);
                              setSampleDocShow(true);
                            }}
                            style={{ textDecoration: 'none' }}
                          >
                            <small id='my-helper-text'>
                              <img src={infoIco} alt='' />
                              View sample document
                            </small>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className='row py-3 justify-content-between'>
                  {sampleDocs.length !== 0 ? (
                    sampleDocs.map((doc: any, index: number) => (
                      <a
                        href='#'
                        style={{ background: '#99834d' }}
                        className='text-decoration-none text-white m-2 p-2 rounded'
                        onClick={() => {
                          setSelectedSampleDoc(doc);
                          setDocType(doc.resource.split('.').pop());
                          setSampleDocView(true);
                        }}
                      >
                        <span className='mx-1'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            height='18px'
                            viewBox='0 0 24 24'
                            width='18px'
                            fill='#ffffff'
                          >
                            <path d='M0 0h24v24H0z' fill='none' />
                            <path d='M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z' />
                          </svg>
                        </span>
                        {doc.name}
                      </a>
                    ))
                  ) : (
                    <div className='mt-2 text-center'>No sample documents</div>
                  )}
                </div>
              )}
            </>
          ) : (
            <div className='mt-3'>
              {docType === 'pdf' ? (
                <iframe
                  id='iframe'
                  frameBorder='0'
                  scrolling='no'
                  src={`${
                    process.env.REACT_APP_URL
                  }/order/b2b/buyback/invoice/download/${encodeURIComponent(
                    selectedSampleDoc.resource
                  )}#toolbar=0`}
                  width='100%'
                  height='433px'
                />
              ) : (
                <img
                  style={{ width: '-webkit-fill-available' }}
                  src={`${
                    process.env.REACT_APP_URL
                  }/order/b2b/buyback/invoice/download/${encodeURIComponent(
                    selectedSampleDoc.resource
                  )}`}
                  alt=''
                />
              )}
              <div className='d-grid mt-4'>
                <button
                  type='button'
                  onClick={(event) => {
                    download(selectedSampleDoc.resource);
                  }}
                  className='btn-block btn btn-primary btn-lg'
                >
                  Download
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DocumentUpload;
